import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import "./SessionExpiryModal.scss";

const SessionExpiryModal = ({
  showModal,
  expired,
  remainingTime,
  continuePending = false,
  onContinue,
  onLoginAgain,
  onLogOut,
}) => {
  return (
    showModal && (
      <Dialog
        open={showModal}
        className="session-expiry-container"
        aria-labelledby="session-expiry-dialog"
      >
        <div className="session-expiry-top-bar" />

        <div className="session-expiry-innercontainer">
          <div className="session-expiry-text-wrapper">
            <div className="session-exp-title-container">
              <div className="session-expiry-title">SESSION TIME OUT</div>
            </div>

            <div className="session-exp-message-container" style={{padding: remainingTime < 10 ? '12px 20px' : '12px 18px'}}>
              <div className="session-expiry-message">
                {!expired ? (
                  <>
                    <span className="red-text">
                    Your session is about to expire in {remainingTime} sec.
                    </span>
                    <span>Would you like to continue?</span>
                  </>
                ) : (
                  <>
                    <span className="red-text">Your session has expired.</span>
                    <span>All changes have been saved.</span>
                    <br />
                    <span>Please log in again to continue working.</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <DialogActions className="sessionExpiryFooterContainer">
          {!expired ? (
            <div className="sessionExpiryBtnContainer">
              <Button onClick={onLogOut} className="footer-plain-btn">
                LOG OUT
              </Button>
              <Button
                onClick={onContinue}
                disabled={continuePending}
                className="sessionExpiryBtn Footer-btns"
              >
                {continuePending ? "CONTINUING…" : "CONTINUE SESSION"}
              </Button>
            </div>
          ) : (
            <Button
              onClick={onLoginAgain}
              className="sessionExpiryBtn Footer-btns"
            >
              LOGIN
            </Button>
          )}
        </DialogActions>
      </Dialog>
    )
  );
};

export default SessionExpiryModal;
